<template>
  <!-- 选择小组弹窗 -->
  <div class="vmp-group-choose">
    <vh-dialog
      :visible="dialogVisible"
      @open="handleOpen"
      :before-close="handleClose"
      :close-on-click-modal="false"
      width="400px"
      :title="$t('host.k_550001')"
    >
      <vh-form class="group-form">
        <vh-form-item :label="$t('host.k_550002')" label-width="70px">
          <vh-select v-model="selectGroup" style="width: 100%" :placeholder="$t('host.k_550003')">
            <vh-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></vh-option>
          </vh-select>
        </vh-form-item>
      </vh-form>

      <!-- 底部按钮 -->
      <div slot="footer" class="vmp-group-ft">
        <vh-button plain type="info" :round="true" @click="handleClose">
          {{ $t('host.k_550004') }}
        </vh-button>
        <vh-button type="primary" :round="true" @click="handleSubmit">
          {{ $t('host.k_550005') }}
        </vh-button>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useGroupServer } from 'middle-domain';
  export default {
    name: 'VmpGroupChoose',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dialogVisible: this.show,
        selectGroup: '',
        options: []
      };
    },
    beforeCreate() {
      this.groupServer = useGroupServer();
    },
    computed: {
      // 已分组人员列表
      groupedUserList() {
        return this.groupServer.state.groupedUserList;
      }
    },
    watch: {
      show: function (newVal) {
        this.dialogVisible = newVal;
      }
    },
    methods: {
      // 确认换组
      handleSubmit() {
        this.$emit('chooseGroupComplete', this.selectGroup);
      },
      // 对话框打开时，设置可选小组
      handleOpen() {
        this.selectGroup = '';
        this.options = this.groupedUserList.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('update:show', false);
      }
    }
  };
</script>
<style lang="less">
  .vmp-group-choose {
    .vh-dialog__body {
      min-height: 32px !important;
    }

    .group-form {
      .vh-form-item {
        margin-bottom: 0px;
        .vh-form-item__label {
          color: #1a1a1a;
          font-weight: 400;
        }
        .vh-form-item__content {
          margin-left: 70px;
        }
      }
    }
  }
</style>
